var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThumbsUp = function SvgThumbsUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#vzzrufy1xa)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.88 8.13C21.59 8.04 21.3 8 21 8h-6V5C15 2.47 13.71.71 11.46.17a2 2 0 0 0-2.41 1.49c-.04.15-.05.31-.05.46v3.52l-3 3.6V9H0v14h6V12.36l5-6V2.11c1.35.33 2 1.27 2 2.89v5h8c.1 0 .2.01.29.04.53.16.82.72.66 1.25l-2.77 9a1 1 0 0 1-.96.71H7.99v2h10.23c1.33 0 2.48-.85 2.87-2.12l2.77-9c.49-1.58-.41-3.26-1.98-3.75zM4 21H2V11h2v10z",
    fill: "#D64309"
  }))));
};
export default SvgThumbsUp;